<template>
  <div>
    <header-sales></header-sales>
    <!-- pc view -->
    <div v-if="!mobileView"> 
        <div id="subheader"> </div>
        <div id="main-container">
        <div id="label-container">
            <span id="label">Nuevo Cliente</span>
        </div>


        <div id= "container">

            <div class="fv lt" style="width: 100%; height: 100%; background: white">
                <div class="fh lt" style="width: 100%; background: #f0f0f0">
                  <div class="labels-forms" style="padding-left: 10px; padding-top: 10px; padding-bottom: 5px; font-size: 15px; font-weight: 500">Informacióm Básica</div>
                </div>


                <div class="fh lt" style="width: 100%; height: 60px; margin-top: 5px">
                    <div class="fv lt" style="width: 25%; height: 100%; padding-left: 10px">
                        <div class="labels-forms">Nombre(*)</div>
                        <input :class="[errorNombre ? 'inpt-error' : 'inpt']"  type="text" v-model='nombre' >
                    </div>
                    <div class="fv lt" style="width: 25%; height: 100%; padding-left: 10px;  background: white">
                        <div class="labels-forms">Contacto</div>
                        <input class="inpt"  type="text" v-model='contacto'>
                    </div>
                    <div class="fv lt" style="width: 25%; height: 100%; padding-left: 10px;  background: white">
                        <div class="labels-forms">Teléfono</div>
                        <input class="inpt"  type="tel" v-model='telefono'>
                    </div>
                    <div class="fv lt" style="width: 25%; height: 100%; padding-left: 10px;  background: white">
                        <div class="labels-forms">Correo electrónico</div>
                        <input :class="[errorEmail ? 'inpt-error' : 'inpt']"  type="email" v-model='email'>
                    </div>
                </div>    

                <div class="fh lt" style="width: 100%; height: 60px">
                    <div class="fv lt" style="width: 25%; height: 100%; padding-left: 10px;  background: white">
                        <div class="labels-forms">Inicio horario de atención</div>
                        <input class="inpt"  type="time" v-model="hIniAte">
                    </div>
                    <div class="fv lt" style="width: 25%; height: 100%; padding-left: 10px;  background: white">
                        <div class="labels-forms">Fin horario de atención</div>
                        <input class="inpt"  type="time" v-model="hFinAte">
                    </div>
                    <div class="fv lt" style="width: 25%; height: 100%; padding-left: 10px;  background: white">
                        <div class="labels-forms">Inicio horario de recepción</div>
                        <input class="inpt"  type="time" v-model="hIniRecep">
                    </div>
                    <div class="fv lt" style="width: 25%; height: 100%; padding-left: 10px;  background: white">
                        <div class="labels-forms">Fin horario de recepción</div>
                        <input class="inpt"  type="time" v-model="hFinRecep">
                    </div>
                </div>    

                <div class="fh lt" style="width: 100%; height: 60px">
                    <div class="fv lt" style="width: 25%; height: 100%; padding-left: 10px">
                        <div class="labels-forms">Ciudad</div>
                        <input class="inpt" type="text" v-model='ciudad'>
                    </div>
                    <div class="fv lt" style="width: 50%; height: 100%; padding-left: 10px">
                        <div class="labels-forms">Dirección</div>
                        <input class="inpt" style="width:365px" type="text" ref="autocompletePc">
                    </div>
                    <div class="fv lt" style="width: 25%; height: 100%; padding-left: 5px;  background: white">
                        <div class="labels-forms">Observaciones</div>
                        <input class="inpt" type="text" v-model='observaciones'>
                    </div>
                </div>    
              
                <div class="fh lt" style="width: 100%; background: #f0f0f0">
                  <div class="labels-forms" style="padding-left: 10px; padding-top: 10px; padding-bottom: 5px; font-size: 15px; font-weight: 500">Datos Fiscales</div>
                </div>

                <div class="fh lt" style="width: 100%; height: 60px; background: white; margin-top: 5px">
                    <div class="fv lt" style="width: 25%; height: 100%; padding-left: 10px">
                        <div class="labels-forms">{{idFiscalProp}}</div>
                        <input :class="[errorIdFiscal ? 'inpt-error' : 'inpt']" type="text" v-model='idFiscal'>
                    </div>
                    <div class="fv lt" style="width: 25%; height: 100%; padding-left: 10px">
                        <div class="labels-forms">Razon social</div>
                        <input class="inpt" type="text" v-model='razonSocial'>
                    </div>
                    <div class="fv lt" style="width: 50%; height: 100%; padding-left: 10px">
                    </div>
                </div>    
                <div class="fh lt" style="width: 100%; background: #f0f0f0">
                  <div class="labels-forms" style="padding-left: 10px; padding-top: 10px; padding-bottom: 5px; font-size: 15px; font-weight: 500">Datos Financieros</div>
                </div>

                <div class="fh lt" style="width: 100%; height: 60px; margin-top: 5px">
                    <div class="fv lt" style="width: 25%; height: 100%; padding-left: 10px;  background: white">
                        <div class="labels-forms">Agrupación(*)</div>
                        <select :class="[errorAgrupacion ? 'wc-error' : 'wc']" v-model="agrupacion" style="width: 180px;">
                            <option v-for="option in agrupaciones" v-bind:value="option">{{ option.Nombre }}</option>
                        </select>
                    </div>
                    <div class="fv lt" style="width: 25%; height: 100%; padding-left: 10px;  background: white">
                        <div class="labels-forms">Tipo cliente(*)</div>
                        <select :class="[errorTipoCliente ? 'wc-error' : 'wc']" v-model="tipoCliente" style="width: 180px;">
                            <option v-for="option in tipoClientes" v-bind:value="option">{{ option.Nombre }}</option>
                        </select>
                    </div>
                    <div class="fv lt" style="width: 25%; height: 100%; padding-left: 10px;  background: white">
                        <div class="labels-forms">Lista de precio(*)</div>
                        <select :class="[errorListaPrecio ? 'wc-error' : 'wc']" v-model="listaPrecio" style="width: 180px;">
                            <option v-for="option in listaPrecios" v-bind:value="option">{{ option.Nombre }}</option>
                        </select>
                    </div>
                    <div class="fv lt" style="width: 25%; height: 100%; padding-left: 10px;  background: white">
                        <div class="labels-forms">Depósito(*)</div>
                        <select :class="[errorDeposito ? 'wc-error' : 'wc']" v-model="deposito" style="width: 180px;">
                            <option v-for="option in depositos" v-bind:value="option">{{ option.Nombre }}</option>
                        </select>
                    </div>
                </div>    
            </div>

        </div>

            <div class="fh rc" style="text-align: center;margin-top: 30px;">
                <button id="btnok" @click="saveCliente">GUARDAR</button>
                <button id="btncancel" @click="exit">CANCELAR</button>
            </div>
        </div> 
     </div>


    <!-- mobile view -->
    <div v-if="mobileView" style="margin-top: 40px">

        <div class="fh cc" style="width: 100vw; height:4vh; background:#44C7F4; color:white; font: size 12px;">Nuevo Clientes</div>
          <div class="fv ct" style="height:60vh; overflow: auto">

            <div class="labels-forms" style="padding-left: 10px; padding-top: 10px; padding-bottom: 5px; font-size: 15px; font-weight: 500">Informacióm Básica</div>

            <div class="fv lt" style="width: 90%; padding-left: 10px; margin-top: 20px">
                <div class="fc lt" style="width: 95%; font-size: 12px; color: #5C666F; text-align: left">Nombre(*)</div>
                <input :class="[errorNombre ? 'inpt-cel-error' : 'inpt-cel']"
                              type="text" v-model='nombre' >
            </div>

            <div class="fv lt" style="width: 90%; padding-left: 10px; margin-top: 20px">
                <div class="fc lt" style="width: 95%; font-size: 12px; color: #5C666F; text-align: left">Contacto</div>
                <input class="inpt-cel" type="text" v-model='contacto'>
            </div>

            <div class="fv lt" style="width: 90%; padding-left: 10px; margin-top: 20px">
                <div class="fc lt" style="width: 95%; font-size: 12px; color: #5C666F; text-align: left">Teléfono</div>
                <input :class="[errorEmail ? 'inpt-cel-error' : 'inpt-cel']" type="text" v-model='telefono'>
            </div>

            <div class="fv lt" style="width: 90%; padding-left: 10px; margin-top: 20px">
                <div class="fc lt" style="width: 95%; font-size: 12px; color: #5C666F; text-align: left">Correo electrónico</div>
                <input class="inpt-cel" type="text" v-model='email'>
            </div>

            <div class="fv lt" style="width: 90%; padding-left: 10px; margin-top: 20px">
                <div class="fc lt" style="width: 95%; font-size: 12px; color: #5C666F; text-align: left">Inicio horario de atención</div>
                <input class="inpt-cel" type="time" v-model="hIniAte">
            </div>

            <div class="fv lt" style="width: 90%; padding-left: 10px; margin-top: 20px">
                <div class="fc lt" style="width: 95%; font-size: 12px; color: #5C666F; text-align: left">Fin horario de atención</div>
                <input class="inpt-cel" type="time" v-model="hIniAte">
            </div>


            <div class="fv lt" style="width: 90%; padding-left: 10px; margin-top: 20px">
                <div class="fc lt" style="width: 95%; font-size: 12px; color: #5C666F; text-align: left">Inicio horario de recepción</div>
                <input class="inpt-cel" type="time" v-model="hIniAte">
            </div>


            <div class="fv lt" style="width: 90%; padding-left: 10px; margin-top: 20px">
                <div class="fc lt" style="width: 95%; font-size: 12px; color: #5C666F; text-align: left">Fin horario de recepción</div>
                <input class="inpt-cel" type="time" v-model="hIniAte">
            </div>

            <div class="fv lt" style="width: 90%; padding-left: 10px; margin-top: 20px">
                <div class="fc lt" style="width: 95%; font-size: 12px; color: #5C666F; text-align: left">Ciudad</div>
                <input class="inpt-cel" type="text" v-model='ciudad'>
            </div>
            <div class="fv lt" style="width: 90%; padding-left: 10px; margin-top: 20px">
                <div class="fc lt" style="width: 95%; font-size: 12px; color: #5C666F; text-align: left">Dirección</div>
                <input class="inpt-cel" type="text" ref="autocompleteMobile">

            </div>
            <div class="fv lt" style="width: 90%; padding-left: 10px; margin-top: 20px">
                <div class="fc lt" style="width: 95%; font-size: 12px; color: #5C666F; text-align: left">Observaciones</div>
                <input class="inpt-cel" type="text" v-model='observaciones'>
            </div>

            <div class="labels-forms" style="padding-left: 10px; padding-top: 30px; font-size: 15px; font-weight: 500">Datos Fiscales</div>


            <div class="fv lt" style="width: 90%; padding-left: 10px; margin-top: 10px">
                <div class="fc lt" style="width: 95%; font-size: 12px; color: #5C666F; text-align: left">{{idFiscalProp}}</div>
                <input :class="[errorIdFiscal ? 'inpt-cel-error' : 'inpt-cel']"
                            type="text" v-model='idFiscal'>
            </div>
            <div class="fv lt" style="width: 90%; padding-left: 10px; margin-top: 20px">
                <div class="fc lt" style="width: 95%; font-size: 12px; color: #5C666F; text-align: left">Razon social</div>
                <input class="inpt-cel" type="text" v-model='razonSocial'>
            </div>


            <div class="labels-forms" style="padding-left: 10px; padding-top: 30px; font-size: 15px; font-weight: 500">Datos Financieros</div>

            <div class="fv lt" style="width: 90%; padding-left: 10px; margin-top: 10px">
            <div class="fc lt" style="width: 95%; font-size: 12px; color: #5C666F; text-align: left">Agrupación(*)</div>
                <select :class="[errorAgrupacion ? 'wc-error' : 'wc']" v-model="agrupacion" style=" padding-left: 10px; padding-right: 10px; width:90%">
                    <option v-for="option in agrupaciones" v-bind:value="option">{{ option.Nombre }}</option>
                </select>
            </div>
            <div class="fv lt" style="width: 90%; padding-left: 10px; margin-top: 20px">
                <div class="fc lt" style="width: 95%; font-size: 12px; color: #5C666F; text-align: left">Tipo cliente(*)</div>
                <select :class="[errorTipoCliente ? 'wc-error' : 'wc']" v-model="tipoCliente" style=" padding-left: 10px; padding-right: 10px; width:90%">
                    <option v-for="option in tipoClientes" v-bind:value="option">{{ option.Nombre }}</option>
                </select>
            </div>
            <div class="fv lt" style="width: 90%; padding-left: 10px; margin-top: 20px">
                <div class="fc lt" style="width: 95%; font-size: 12px; color: #5C666F; text-align: left">Lista de precio(*)</div>
                <select :class="[errorListaPrecio ? 'wc-error' : 'wc']" v-model="listaPrecio" style=" padding-left: 10px; padding-right: 10px; width:90%">
                    <option v-for="option in listaPrecios" v-bind:value="option">{{ option.Nombre }}</option>
                </select>
            </div>
            <div class="fv lt" style="width: 90%; padding-left: 10px; margin-top: 20px">
                <div class="fc lt" style="width: 95%; font-size: 12px; color: #5C666F; text-align: left">Depósito(*)</div>
                <select :class="[errorDeposito ? 'wc-error' : 'wc']" v-model="deposito" style=" padding-left: 10px; padding-right: 10px; width:90%">
                    <option v-for="option in depositos" v-bind:value="option">{{ option.Nombre }}</option>
                </select>
            </div>

          </div> 
        <div class="fh cc" style="width: 100vw; height:19vh;">
            <button id="btnok" @click="saveCliente">GUARDAR</button>
            <button id="btncancel" @click="exit">CANCELAR</button>
        </div>



    </div> 
  </div>
</template>

<script>
import axios from 'axios'
import HeaderSales from '@components/views/header.vue';

export default {
  components: {
    'header-sales': HeaderSales
  },
  data () {
    return {
      filter: null,
      cliente: null,
      clientes: [],
      clienteModificado:false,
      mobileView:false,
      nombre: '',
      contacto: '',
      telefono: '',
      email: '',
      hIniAte: '',
      hFinAte: '',
      hIniRecep: '',
      hFinRecep: '',
      ciudad: '', 
      direccion: '', 
      observaciones: '',
      idFiscal: '', 
      razonSocial: '',
      agrupacion: '', 
      tipoCliente: '', 
      listaPrecio: '', 
      deposito: '',
      agrupaciones: [], 
      tipoClientes: [], 
      listaPrecios: [], 
      depositos: [],
      lat: 0,
      long: 0,
      errorNombre: false,
      errorIdFiscal: false,
      errorAgrupacion: false,
      errorTipoCliente: false,
      errorListaPrecio: false,
      errorDeposito: false,
      errorEmail: false
    }
  },

    
  computed: {
    idFiscalProp () {
      if (this.$store.state.user.usuario.NroFiscalObligatorio) {
        return 'ID Fiscal(*)'
      }
      else {
        return 'ID Fiscal'
      }
    } 
  },



 mounted() {
  this.onResize()
  this.dataset1()

  this.loadGoogleMaps().then(() => {


    this.$nextTick(() => {
      //const input = this.$refs.autocomplete

      const input = this.mobileView
        ? this.$refs.autocompleteMobile
        : this.$refs.autocompletePc


      if (!(input instanceof HTMLInputElement)) {
        console.error('NO es un input HTML real')
        return
      }
      const autocomplete = new google.maps.places.Autocomplete(input, {
        types: ['geocode'],
        componentRestrictions: { country: 'ar' }
      })
      autocomplete.addListener('place_changed', () => {
        const place = autocomplete.getPlace()
        this.lat = place.geometry.location.lat()
        this.long = place.geometry.location.lng()
        this.direccion = place.formatted_address
        for (var i = 0; i < place.address_components.length; i++) {
          if (place.address_components[i].types.indexOf('locality') !== -1) {
            this.ciudad = place.address_components[i].long_name
          }
        }
      })
    })





  })
 },

  
  methods: {

   onResize() {
      if (window.innerWidth > 600) 
      {
        this.mobileView=false;
      }
      else 
      {
        this.mobileView=true;
      }
    },

    loadGoogleMaps() {
      return new Promise((resolve) => {
        if (window.google) {
          resolve()
          return
        }
        const script = document.createElement('script')
        script.src = 'https://maps.googleapis.com/maps/api/js?key=AIzaSyBDB-1waUzjTq-_c1yK0k7y052lpMBK_fQ&libraries=places'
        script.onload = resolve
        document.head.appendChild(script)
      })
    },

    validarForm() {
      this.errorNombre = !this.nombre || this.nombre === ''
      this.errorAgrupacion = !this.agrupacion || this.agrupacion === ''
      this.errorTipoCliente = !this.tipoCliente || this.tipoCliente === ''
      this.errorListaPrecio = !this.listaPrecio || this.listaPrecio === ''
      this.errorDeposito = !this.deposito || this.deposito === ''

      if (this.$store.state.user.usuario.NroFiscalObligatorio) {
        this.errorIdFiscal = !this.idFiscal || this.idFiscal === ''
      }

      if (this.email != '') {
        this.errorEmail = !this.validarEmail(this.email)
      }

      if (this.errorNombre || this.errorAgrupacion || this.errorTipoCliente || this.errorListaPrecio || this.errorDeposito) {
        return false            
      }
      else if ((this.$store.state.user.usuario.NroFiscalObligatorio) && (this.errorIdFiscal)){ 
        return false            
      }
      else {
        return true
      }

    },

    dataset1(){
        this.$store.commit('loader/start')
        axios.get('/WebSalesPrecios/Get',{
        headers:{
                    Token:        this.$store.state.user.usuario.Token,
                    ClientSecret: this.$store.state.entorno.clientSecret,
                    EmpresaId:    this.$store.state.entorno.idEmpresa
                }
        }).then((response) => {
            if (response.data.Code == 0) {
            this.listaPrecios = response.data.ListasPrecio
            this.dataset2()
            }
        },(error) => {
            this.$store.commit('loader/stop')
            alert(error);
        })
     }, 


    dataset2(){
        axios.get('/WebSalesCliente?ClienteId='+ this.$route.query.id,{
        headers:{
                    Token:        this.$store.state.user.usuario.Token,
                    ClientSecret: this.$store.state.entorno.clientSecret,
                    EmpresaId:    this.$store.state.entorno.idEmpresa
                }
        }).then((response) => {
            this.$store.commit('loader/stop')
            if (response.data.Code == 0) {
            this.agrupaciones = response.data.Cadenas
            this.tipoClientes = response.data.TiposDomicilio
            this.depositos = response.data.Depositos
            }
        },(error) => {
            this.$store.commit('loader/stop')
            alert(error);
        })
    }, 

    validarEmail(email) {
        const regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/
        return regex.test(email)
    },

    saveCliente () {
      if (this.validarForm()) {
        var cliente = {
            'Id': 0,
            'EmpleadoId': this.$store.state.user.usuario.EmpleadoId,
            'RazonSocial': this.razonSocial,
            'Nombre': this.nombre,
            'Direccion': this.direccion,
            'Localidad': this.ciudad,
            'FiscalNro': this.idFiscal,
            'Contacto': this.contacto,
            'Telefono':	this.telefono,
            'Email': this.email,
            'Observaciones': this.observaciones,
            'Latitud':	this.lat,
            'Longitud':	this.long,
            'TipoPDVId': this.tipoCliente.Id,
            'ListaPrecioId': this.listaPrecio.Id,
            'DepositoId': this.deposito.Id,
            'CadenasId': [this.agrupacion.Id],
            'HorarioAtencionInicio': this.hIniAte,
            'HorarioAtencionFin': this.hFinAte,
            'HorarioRecepcionInicio': this.hIniRecep,
            'HorarioRecepcionFin': this.hFinRecep,
            'CodigoHash': Math.floor(Math.random() * 1000000000)
        }  

          console.log('<<<<1>>>>')
          console.log(cliente)

          this.$store.commit('loader/start')
          axios.post('/WebSalesCliente', cliente ,{
            headers:{
                Token:        this.$store.state.user.usuario.Token,
                ClientSecret: this.$store.state.entorno.clientSecret,
                EmpresaId:    this.$store.state.entorno.idEmpresa
            }
          })
          .then((response) => {
            this.showPopup = false;
            console.log('<<<<2>>>>')
            console.log(response)
            this.$store.commit('loader/stop')
            if (response.data.Code == 0) {
              var obj = {
                    txt:'Nuevo cliente creado',
                    txtBtnCancel:"",
                    txtBtnOk:'Aceptar',
                    fCancel:null,
                    fOk:this.exit
                }
              this.$store.commit('popup/open',obj);
            }
          })
          .catch((error) => {
             alert(error);  
          });
     }

    },


    exit () {
      this.$store.commit('popup/close');
      this.$router.push({ name: "clientes" });
    },

  },


  created() {
    window.addEventListener('resize', this.onResize)
  },

  beforeDestroy() {
    window.removeEventListener('resize', this.onResize)
  }
}
</script>

<style scoped>



.wc{
  background-color: #ffffff;
  width: 170px;
  border-radius: 5px;
  height: 30px;
  border-style: solid;
  border: none;
  border-width: 1px;
  border: 1px solid #dddddd;
  -ms-box-sizing:content-box;
  -moz-box-sizing:content-box;
  box-sizing:content-box;
  -webkit-box-sizing:content-box; 
}

.wc-error{
  background-color: #ffffff;
  width: 170px;
  border-radius: 5px;
  height: 30px;
  border-style: solid;
  border: none;
  border-width: 1px;
  border: 1px solid red;
  -ms-box-sizing:content-box;
  -moz-box-sizing:content-box;
  box-sizing:content-box;
  -webkit-box-sizing:content-box; 
}



.labels-forms{
 font-size: 12px;
 color: #5C666F;
 text-align: left;
}


.inpt{
  width:170px;
  height:30px;
  font-size: 15px;
  text-align: left;
  padding-left: 10px;
  color:#5D6770;
  border-radius: 5px;  
  border:none; 
  border-style: solid;
  border-width: 1px;
  border: 1px solid #dddddd;
} 


 .inpt-error{
    width:170px;
    height:30px;
    font-size: 15px;
    text-align: left;
    padding-left: 10px;
    color:#5D6770;
    border-radius: 5px;  
    border:none; 
    border-style: solid;
    border-width: 1px;
    border: 1px solid red !important;
 }
  


.inpt-cel{
  width:90%;
  height:30px;
  font-size: 15px;
  text-align: left;
  padding-left: 10px;
  padding-right: 10px;
  font-weight: 100;
  color:#5D6770;
  border-radius: 5px;  
  border:none; 
  border-style: solid;
  border-width: 1px;
  border: 1px solid #dddddd;
} 


 .inpt-cel-error{
  width:90%;
  height:30px;
  font-size: 15px;
  text-align: left;
  padding-left: 10px;
  padding-right: 10px;
  font-weight: 100;
  color:#5D6770;
  border-radius: 5px;  
  border:none; 
  border-style: solid;
  border-width: 1px;
  border: 1px solid red !important;
 }





#list-container{
    width: 630px;
    height: 49vh;
    margin-left: 25px;
    margin-right: 25px;
    overflow: auto;
    background-color: #ffffff;
}


#btnok {
  width: 100px;
  height: 30px;
  margin-left: 5px;
  margin-right: 5px;
  font-size: 9px;
  border-style: solid;
  border:none;
  background: #44C7F4;
  border-radius: 20px;
  color: #ffffff;
  outline: none;
}

#btncancel {
  width: 120px;
  height: 30px;
  font-size: 9px;
  margin-left: 5px;
  margin-right: 5px;
  border-style: solid;
  border:none;
  color: #4969B2;
  background: #ffffff;
  border-radius: 20px;
  border-width: 1px;
  border: 1px solid #4969B2;
  outline: none;
}


  #subheader {
    width: 100%;
    height: 35vh;
    background: linear-gradient(#005A9F , #1899D6);
    }


   #main-container{
    position: absolute;
    top: 55vh;
    left: 50%;
    transform: translate(-50%,-50%);
    width: 800px;
    height: 85vh;
    }


   #label-container{
     width: 700px;
     height: 10vh;
    }

   #label{
     color:#ffffff;
     font-size: 27px;
    }


   #container{
     width: 800px;
     height: 65vh;
     border-width: 1px;
     border: 1px solid #dddddd;
     box-sizing: border-box;
     background-color: #ffffff;
    }

   #list-header-container{
     height: 13vh;
     display: flex;
     flex-direction: column;
     justify-content: center;
     align-items: center;
     background-color: #ffffff;
    }

   #busqueda{
    border-radius: 20px;
    max-width: 400px; 
    width: 70vw;
    margin-top:15px;
    padding-left: 40px;
    height:30px;
    border-style: solid;
    border:none;
    border-width: 1px;
    border: 1px solid #dddddd;
    color: #000000;
    outline: none;
    background: white url(/dist/icon-search.png) left no-repeat ;
    background-size: 25px 25px;
    background-position: 10px;
   }

   #seleccion-container{
    margin-top: 15px;
    display: flex;
    justify-content: center;
    align-items: center;
    background-color: #ffffff;
    }

   .seleccion{
    color:#2292CD;
    font-weight: normal;
    margin-left:0 auto;
    margin-right: 0 auto;
    margin-top: 0px;
    font-size: 11px;
    font-weight: 500;
    text-align: center;
    }


   .seleccion:hover{
       cursor: pointer;
     }


   #separador{
    margin-left: 15px;
    margin-right: 15px;
    font-weight: 500;
    font-size: 13px;
    color:#dddddd;
    }


   #list-container{
    width: 630px;
    height: 49vh;
    margin-left: 25px;
    margin-right: 25px;
    overflow: auto;
    background-color: #ffffff;
    }



   #btnContainer{
     width: 660px;
     height: 10vh;
     display: flex;
     flex-direction:row;
     justify-content: flex-end;
     align-items: center;
    }


   #btnAgregarPromo{
     width: 120px;
     height: 30px;
     font-size: 9px;
     margin-left: 5px;
     margin-right: 5px;
     border-style: solid;
     border:none;
     color: #4969B2;
     background: #ffffff;
     border-radius: 20px;
     border-width: 1px;
     border: 1px solid #4969B2;
     outline: none;
   }


   #btnCarrito{
     width: 100px;
     height: 30px;
     margin-left: 5px;
     margin-right: 5px;
     font-size: 9px;
     border-style: solid;
     border:none;
     background: #44C7F4;
     border-radius: 20px;
     color: #ffffff;
     outline: none;
   }

   #btnok:hover{cursor: pointer;}
   #btncancel:hover{cursor: pointer;}

   .fade-enter-active, .fade-leave-active {
     transition-property: opacity;
     transition-duration: .25s;
   }

   .fade-enter-active {
     transition-delay: .25s;
   }

   .fade-enter, .fade-leave-active {
     opacity: 0}





   .fadePro-enter {
     opacity: 0;
   }
   .fadePro-enter-active {
     transition: opacity 0.5s;
   }
   .fadePro-enter-to {
     opacity: 1;
   }
   .fadePro-leave {
     opacity: 1;
   }
   .fadePro-leave-active {
     transition: opacity 0.1s;
   }
   .fadePro-leave-to {
     opacity: 0;
   }

   /*-----------------------------------------------------------------------------------------------------------------------*/

   /* width */
   ::-webkit-scrollbar {
       width: 5px;
   }

   /* Track */
   ::-webkit-scrollbar-track {
       box-shadow: inset 0 0 5px #dddddd;
       border-radius: 10px;
   }

   /* Handle */
   ::-webkit-scrollbar-thumb {
       background: #cccccc;
       border-radius: 10px;
   }

   /* Handle on hover */
   ::-webkit-scrollbar-thumb:hover {
       background: #bbbbbb;
   }



   ::placeholder { /* Chrome, Firefox, Opera, Safari 10.1+ */
       color: #dddddd;
       opacity: 1; /* Firefox */
   }

   :-ms-input-placeholder { /* Internet Explorer 10-11 */
       color: #dddddd;
   }

   ::-ms-input-placeholder { /* Microsoft Edge */
       color: #dddddd;
   }
</style>



// WEBPACK FOOTER //
// src/components/views/preselect/altaClientes.vue